var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-user-center" },
    [
      _c("div", { staticClass: "page-user-center__container" }, [
        _c("div", { staticClass: "userinfo-content" }, [
          _c("div", { staticClass: "user-settings" }, [
            _c("div", { staticClass: "user-setting" }, [
              _c("div", { staticClass: "setting-form" }, [
                _vm._m(0),
                _c("div", { staticClass: "setting-form__content" }, [
                  _vm.user.tradeUrl
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "setting-form__text setting-form__text_active",
                        },
                        [_vm._v(" https://steam****")]
                      )
                    : _c("p", { staticClass: "setting-form__text" }, [
                        _vm._v("请绑定交易链接"),
                      ]),
                ]),
                _c("div", { staticClass: "setting-form__actions" }, [
                  !_vm.flag.tradeURL
                    ? _c(
                        "div",
                        {
                          staticClass: "operation-btn",
                          attrs: { width: "84px", padding: "12px" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              _vm.modifyTradeModal.flag = true
                              _vm.modifyTradeModal.url = _vm.user.tradeUrl
                            },
                          },
                        },
                        [_vm._v("绑定 ")]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c("div", { staticClass: "setting-form" }, [
                _vm._m(1),
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "setting-form__actions" },
                  [
                    _c(
                      "Upload",
                      {
                        attrs: {
                          "before-upload": _vm.handleUploadAvatar,
                          action: "",
                        },
                      },
                      [
                        _c("div", { staticClass: "operation-btn" }, [
                          _vm._v("上传"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c("div", { staticClass: "setting-form" }, [
                _c(
                  "label",
                  { staticClass: "setting-form__label" },
                  [
                    _c("Icon", { attrs: { type: "md-body" } }),
                    _c("span", { staticClass: "setting-form__label__text" }, [
                      _vm._v("昵称"),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "setting-form__content" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "setting-form__text setting-form__text_active",
                    },
                    [_vm._v(_vm._s(_vm.user.nickname))]
                  ),
                ]),
                _c("div", { staticClass: "setting-form__actions" }, [
                  _c(
                    "div",
                    {
                      staticClass: "operation-btn",
                      on: {
                        click: function ($event) {
                          _vm.modifyNameModal.flag = true
                        },
                      },
                    },
                    [_vm._v("修改")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c("div", { staticClass: "setting-form" }, [
                _vm._m(3),
                _c("div", { staticClass: "setting-form__content" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "setting-form__text setting-form__text_active",
                    },
                    [_vm._v(_vm._s(_vm.user.phoneNumber))]
                  ),
                ]),
                _c("div", { staticClass: "setting-form__actions" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c("div", { staticClass: "setting-form" }, [
                _vm._m(4),
                _vm._m(5),
                _c("div", { staticClass: "setting-form__actions" }, [
                  _c(
                    "div",
                    {
                      staticClass: "operation-btn",
                      on: {
                        click: function () {
                          return _vm.change_password_modal.toggle()
                        },
                      },
                    },
                    [_vm._v("修改")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c(
                "form",
                {
                  staticClass: "setting-form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return function () {
                        return _vm.sureBindEmail()
                      }.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(6),
                  _c("div", { staticClass: "setting-form__content" }, [
                    !_vm.user.emailAddress && !_vm.flag.mailFlag
                      ? _c("p", { staticClass: "setting-form__text" })
                      : _vm._e(),
                    _vm.user.emailAddress && !_vm.flag.mailFlag
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "setting-form__text setting-form__text_active",
                          },
                          [_vm._v(_vm._s(_vm.user.emailAddress))]
                        )
                      : _vm._e(),
                    _vm.flag.mailFlag
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.modify.mail,
                              expression: "modify.mail",
                            },
                          ],
                          staticClass: "setting-form__input",
                          attrs: {
                            placeholder: "请输入要绑定的邮箱(绑定后不可修改)",
                          },
                          domProps: { value: _vm.modify.mail },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.modify, "mail", $event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "setting-form__actions" }, [
                    _vm.flag.mailFlag
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-btn border",
                            attrs: {
                              width: "84px",
                              padding: "12px",
                              margin: _vm.$screen.mobile
                                ? "2vw 0 0"
                                : "0 12px 0 0",
                            },
                            on: {
                              click: function ($event) {
                                _vm.flag.mailFlag = false
                                _vm.modify.mail = ""
                              },
                            },
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _vm.flag.mailFlag
                      ? _c(
                          "button",
                          {
                            staticClass: "operation-btn",
                            attrs: {
                              width: "84px",
                              padding: "12px",
                              is_submit: "",
                            },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                    !_vm.user.emailAddress && !_vm.flag.mailFlag
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-btn",
                            attrs: { width: "84px", padding: "12px" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                _vm.flag.mailFlag = true
                              },
                            },
                          },
                          [_vm._v(" 绑定")]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c(
                "form",
                {
                  staticClass: "setting-form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return function () {
                        return _vm.sureBindQQ()
                      }.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(7),
                  _c("div", { staticClass: "setting-form__content" }, [
                    !_vm.user.qq && !_vm.flag.qqFlag
                      ? _c("p", { staticClass: "setting-form__text" })
                      : _vm._e(),
                    _vm.user.qq && !_vm.flag.qqFlag
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "setting-form__text setting-form__text_active",
                          },
                          [_vm._v(_vm._s(_vm.user.qq))]
                        )
                      : _vm._e(),
                    _vm.flag.qqFlag
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.modify.qq,
                              expression: "modify.qq",
                            },
                          ],
                          staticClass: "setting-form__input",
                          attrs: { placeholder: "请输入要绑定的QQ" },
                          domProps: { value: _vm.modify.qq },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.modify, "qq", $event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "setting-form__actions" }, [
                    _vm.flag.qqFlag
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-btn border",
                            attrs: {
                              width: "84px",
                              padding: "12px",
                              margin: _vm.$screen.mobile
                                ? "2vw 0 0"
                                : "0 12px 0 0",
                            },
                            on: {
                              click: function ($event) {
                                _vm.flag.qqFlag = false
                                _vm.modify.qq = ""
                              },
                            },
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _vm.flag.qqFlag
                      ? _c(
                          "button",
                          {
                            staticClass: "operation-btn",
                            attrs: {
                              width: "84px",
                              padding: "12px",
                              is_submit: "",
                            },
                          },
                          [_vm._v("保存")]
                        )
                      : _vm._e(),
                    !_vm.user.qq && !_vm.flag.qqFlag
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-btn",
                            attrs: { width: "84px", padding: "12px" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                _vm.flag.qqFlag = true
                              },
                            },
                          },
                          [_vm._v("绑定")]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user-setting" }, [
              _c(
                "form",
                {
                  staticClass: "setting-form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return function () {
                        return _vm.bindCode()
                      }.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._m(8),
                  _c("div", { staticClass: "setting-form__content" }, [
                    !_vm.user.invitation && !_vm.flag.invitationCodeFlag
                      ? _c("p", { staticClass: "setting-form__text" })
                      : _vm._e(),
                    _vm.user.invitation && !_vm.flag.invitationCodeFlag
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "setting-form__text setting-form__text_active",
                          },
                          [_vm._v(_vm._s(_vm.user.invitation))]
                        )
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "setting-form__actions" }, [
                    !_vm.flag.invitationCodeFlag
                      ? _c(
                          "div",
                          {
                            staticClass: "operation-btn",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.checkInvitationModify.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.user.invitation ? "修改" : "绑定")
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "400rem",
            closable: false,
          },
          model: {
            value: _vm.flag.invitationCodeFlag,
            callback: function ($$v) {
              _vm.$set(_vm.flag, "invitationCodeFlag", $$v)
            },
            expression: "flag.invitationCodeFlag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              staticClass: "sign-up",
              attrs: { title: "修改邀请码", has_close_button: "" },
              on: { close_button_click: _vm.cancelInvitationModify },
            },
            [
              _c(
                "form",
                {
                  staticClass: "sign-up__content",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.bindCode.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("label", { staticClass: "sign-up__field" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modify.invitationCode,
                          expression: "modify.invitationCode",
                        },
                      ],
                      staticClass: "sign-up__field__input",
                      attrs: { placeholder: "请输入邀请码" },
                      domProps: { value: _vm.modify.invitationCode },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.modify,
                            "invitationCode",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "setting-form__actions",
                      staticStyle: { width: "100%", "margin-top": "10px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "operation-btn border",
                          on: { click: _vm.cancelInvitationModify },
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "operation-btn",
                          attrs: { is_submit: "" },
                        },
                        [_vm._v("保存")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "c-modal",
        {
          attrs: {
            toggle: _vm.change_password_modal.toggle,
            status: _vm.change_password_modal.store.status,
            content_width: "438px",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "修改密码", has_close_button: "" },
              on: {
                close_button_click: function () {
                  return _vm.change_password_modal.toggle()
                },
              },
            },
            [
              _c("div", { staticClass: "sign-up__content" }, [
                _c("label", { staticClass: "sign-up__field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.modifyModal.phoneNumberFrom.oldpassword,
                        expression: "modifyModal.phoneNumberFrom.oldpassword",
                      },
                    ],
                    staticClass: "sign-up__field__input",
                    attrs: { type: "password", placeholder: "请输入旧密码" },
                    domProps: {
                      value: _vm.modifyModal.phoneNumberFrom.oldpassword,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.modifyModal.phoneNumberFrom,
                          "oldpassword",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c("label", { staticClass: "sign-up__field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.modifyModal.phoneNumberFrom.password,
                        expression: "modifyModal.phoneNumberFrom.password",
                      },
                    ],
                    staticClass: "sign-up__field__input",
                    attrs: { type: "password", placeholder: "请输入新密码" },
                    domProps: {
                      value: _vm.modifyModal.phoneNumberFrom.password,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.modifyModal.phoneNumberFrom,
                          "password",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "submit-button",
                    on: {
                      click: function ($event) {
                        return _vm.ChangePassword()
                      },
                    },
                  },
                  [_vm._v("修改密码")]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": " app-modal",
            "footer-hide": "",
            width: "400rem",
            closable: false,
          },
          model: {
            value: _vm.modifyNameModal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.modifyNameModal, "flag", $$v)
            },
            expression: "modifyNameModal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              staticClass: "sign-up",
              attrs: { title: "修改昵称", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.modifyNameModal.flag = false
                },
              },
            },
            [
              _c("div", { staticClass: "sign-up__content" }, [
                _c("label", { staticClass: "sign-up__field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.modifyNameModal.nickname,
                        expression: "modifyNameModal.nickname",
                      },
                    ],
                    staticClass: "sign-up__field__input",
                    attrs: {
                      type: "text",
                      placeholder: "请输入您的昵称",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.modifyNameModal.nickname },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.modifyNameModal,
                          "nickname",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "submit-button",
                    staticStyle: { width: "100%", "margin-top": "10px" },
                    on: {
                      click: function ($event) {
                        return _vm.submitChangeName()
                      },
                    },
                  },
                  [_vm._v("确认修改")]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("steam-trade-url-modal", {
        attrs: { "initial-url": _vm.modifyTradeModal.url },
        model: {
          value: _vm.modifyTradeModal.flag,
          callback: function ($$v) {
            _vm.$set(_vm.modifyTradeModal, "flag", $$v)
          },
          expression: "modifyTradeModal.flag",
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "400rem",
            closable: false,
          },
          model: {
            value: _vm.visibleSubAccount.flag,
            callback: function ($$v) {
              _vm.$set(_vm.visibleSubAccount, "flag", $$v)
            },
            expression: "visibleSubAccount.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              staticClass: "sign-up",
              attrs: { title: "绑定副号", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.visibleSubAccount.flag = false
                  _vm.visibleSubAccount.uid = null
                  _vm.visibleSubAccount.subProfile = {}
                },
              },
            },
            [
              _c("div", { staticClass: "sign-up__content" }, [
                _c(
                  "label",
                  { staticClass: "sign-up__field" },
                  [
                    _c(
                      "Input",
                      {
                        attrs: { placeholder: "请输入您的UID" },
                        model: {
                          value: _vm.visibleSubAccount.uid,
                          callback: function ($$v) {
                            _vm.$set(_vm.visibleSubAccount, "uid", $$v)
                          },
                          expression: "visibleSubAccount.uid",
                        },
                      },
                      [
                        _c("Icon", {
                          attrs: {
                            slot: "suffix",
                            type: "ios-search",
                            color: "blue",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getSubProfile()
                            },
                          },
                          slot: "suffix",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.visibleSubAccount.subProfile.uid
                  ? _c("div", { staticClass: "sub_profile" }, [
                      _c("div", { staticClass: "avatar" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.visibleSubAccount.subProfile.avatar
                              ? _vm.$imgfilter(
                                  _vm.visibleSubAccount.subProfile.avatar
                                )
                              : require("@/assets/images/user/ava_none.jpg"),
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("div", { staticClass: "id" }, [
                          _vm._v(
                            "uid: " +
                              _vm._s(_vm.visibleSubAccount.subProfile.uid)
                          ),
                        ]),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            "name：" +
                              _vm._s(_vm.visibleSubAccount.subProfile.name)
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "submit-button",
                    staticStyle: { width: "100%", "margin-top": "10px" },
                    on: {
                      click: function ($event) {
                        return _vm.addSubAccount()
                      },
                    },
                  },
                  [_vm._v("确认")]
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-logo-steam" }),
      _c("span", { staticClass: "setting-form__label__text" }, [
        _vm._v("STEAM"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-md-contact" }),
      _c("span", { staticClass: "setting-form__label__text" }, [
        _vm._v("头像"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "setting-form__content" }, [
      _c("p", { staticClass: "setting-form__text setting-form__text_active" }, [
        _vm._v("请上传头像"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-ios-phone-portrait" }),
      _c("span", { staticClass: "setting-form__label__text" }, [
        _vm._v("手机"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-md-medical" }),
      _c("span", { staticClass: "setting-form__label__text" }, [
        _vm._v("密码"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "setting-form__content" }, [
      _c("p", { staticClass: "setting-form__text setting-form__text_active" }, [
        _vm._v("***********"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-ios-mail" }),
      _c("span", { staticClass: "setting-form__label__text" }, [
        _vm._v("邮箱"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-md-chatboxes" }),
      _c("span", { staticClass: "setting-form__label__text" }, [_vm._v("QQ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "setting-form__label" }, [
      _c("i", { staticClass: "ivu-icon ivu-icon-md-share" }),
      _c("span", { staticClass: "setting-form__label__text" }, [
        _vm._v("邀请码"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }